<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <router-link to="/couponMaster">Coupons</router-link>
        </li>
      </ol>
      <div class="row">
        <div class="col-md-3">
          <div id="search-box1">
            <div class="form-group">
              <label>From Date</label>
              <input
                type="date"
                class=" form-control"
                :max="searchTo"
                v-model="searchFrom"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box2">
            <div class="form-group">
              <label>To Date</label>
              <input
                type="date"
                class=" form-control"
                :min="searchFrom"
                v-model="searchTo"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>Applicable For Partner *</label><br />

            <input type="checkbox" id="selectAll" v-model="selectAll" /> &nbsp;
            <label for="selectAll">Select all partners</label> <br />
            <div
              class="col-md-3"
              v-for="(value, key, index) in userList"
              :key="index"
            >
              <input
                type="checkbox"
                :id="key"
                v-model="PartnerMultiSelect"
                :value="value.id"
              />
              &nbsp;
              <label :for="key">{{ value.name }}</label>
            </div>           
          </div>

            <div class="col">
            <div class="form-group">
              <b>Export To CSV</b>, Max 5,00,000 records can be exported in a part:
              <i v-for="n in Math.ceil(TotalCoupon/500000)" :key="n">
              <button 
                type="button"
                v-on:click="exportReport(n)"
                class="btn btn-raised btn-primary submitbtn"
              >
                Part-{{n}}
              </button> | 
            </i>
            </div>
          </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            @click="filterTotalCoupon"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == '' }"
          >
            Total Coupons <span class="badge"> {{ TotalCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterAvaialable"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'Available' }"
          >
            Marry Coupons <span class="badge"> {{ AvailableCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterNewGenerated"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'NewGenerate' }"
          >
            New Generated Coupons
            <span class="badge"> {{ GeneratedCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterAccumulate"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'Accumulate' }"
          >
            Accumulated Coupon
            <span class="badge"> {{ AccumulatedCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterUnused"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'UnusedExpired' }"
          >
            Unused Expired Coupon
            <span class="badge"> {{ UnusedExpiredCoupon }}</span>
          </button>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>          
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <th>Points</th>
                    <th>Product Name</th>
                    <th v-if="PartnerMultiSelect.includes('Reborer')">Reborer Status</th>
                    <th v-if="PartnerMultiSelect.includes('Reborer')">Reborer Scan Date</th>  

                    <th v-if="PartnerMultiSelect.includes('Mechanics')">Mechanic Status</th>
                    <th v-if="PartnerMultiSelect.includes('Mechanics')">Mechanic Scan Date</th>

                    <th v-if="PartnerMultiSelect.includes('Grinder')">Grinder Status</th>
                    <th v-if="PartnerMultiSelect.includes('Grinder')">Grinder Scan Date</th>

                    <th v-if="PartnerMultiSelect.includes('ReborerPlusGrinder')">Grinder Reborer Status</th>
                    <th v-if="PartnerMultiSelect.includes('ReborerPlusGrinder')">Grinder Scan Date</th>

                    <th v-if="PartnerMultiSelect.includes('Retailer')">Retailer Status</th>
                     <th v-if="PartnerMultiSelect.includes('Retailer')">Retailer Scan Date</th>
                    <th>Expire Date</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">                      
                      {{ item.coupon }}
                    </td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td v-if="PartnerMultiSelect.includes('Reborer')">{{item.ReborerStatus}}</td>
                    <td v-if="PartnerMultiSelect.includes('Reborer')">{{item.reborer_scan_date }}</td>
                    
                    <td v-if="PartnerMultiSelect.includes('Mechanics')">{{item.MechanicStatus}}</td>
                    <td v-if="PartnerMultiSelect.includes('Mechanics')">{{item.Mechanic_scan_date }}</td>

                    <td v-if="PartnerMultiSelect.includes('Grinder')">{{ item.GrinderStatus }}</td>
                     <td v-if="PartnerMultiSelect.includes('Grinder')">{{ item.Grinder_scan_date }}</td>

                    <td v-if="PartnerMultiSelect.includes('ReborerPlusGrinder')">{{ item.GrinderReborerStatus }}</td>
                    <td v-if="PartnerMultiSelect.includes('ReborerPlusGrinder')">{{ item.GrinderReborer_scan_date }}</td>

                    <td v-if="PartnerMultiSelect.includes('Retailer')">{{ item.RetailerStatus }}</td>
                    <td v-if="PartnerMultiSelect.includes('Retailer')">{{ item.Retailer_scan_date }}</td>
                    <td>{{ item.expire_date }}</td>
                    <td>
                      {{
                        item.modified_date
                          ? item.modified_date
                          : item.created_date 
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment';
export default {
  name: 'coupons',
  data() {
    return {
      coupon_data: [],
      searchText: '',
      searchFrom: '',
      searchTo: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message: '',
      AvailableCoupon: 0,
      GeneratedCoupon: 0,
      AccumulatedCoupon: 0,
      UnusedExpiredCoupon: 0,
      TotalCoupon: 0,
      FilterSetOnClick: '',
      PartnerMultiSelect:[],
      userList: [ 
            { "id": "Grinder", "name": "Grinder" }, 
            { "id": "Mechanics", "name": "Mechanics" }, 
            { "id": "Reborer", "name": "Reborer" },            
            { "id": "Retailer", "name": "Retailer" },
            { "id": "ReborerPlusGrinder", "name": "Reborer Plus Grinder" }
        ], 
        exportData:false,
    };
  },
  components: {
    Paginate,
  },
  methods: {
    filterTotalCoupon() {
      this.FilterSetOnClick = '';
      this.getAllCoupons(1);
    },
    filterNewGenerated() {
      this.FilterSetOnClick = 'NewGenerate';
      this.getAllCoupons(1);
    },
    filterAvaialable() {
      this.FilterSetOnClick = 'Available';
      this.getAllCoupons(1);
    },
    filterAccumulate(){
      this.FilterSetOnClick = 'Accumulate';
      this.getAllCoupons(1);
    },
    filterUnused(){
      this.FilterSetOnClick = 'UnusedExpired';
      this.getAllCoupons(1);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (this.FilterSetOnClick) {
        params['FilterSetOnClick'] = this.FilterSetOnClick;
      }
     
        params['coloumnSelected'] = this.PartnerMultiSelect;
        
      if(this.exportData){
        params['exportData'] = this.exportData;
      }        
        
      if(this.searchFrom){
        params['searchFrom'] = this.searchFrom;
      }        
      if(this.searchTo){
        params['searchTo'] = this.searchTo;
      }        
     

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/reportList', params)
        .then((response) => {
          const {
            coupon_data,
            totalItems,
            currentPage,
            TotalPage,
            AvailableCoupon,
            GeneratedCoupon,
            AccumulatedCoupon,
            UnusedExpiredCoupon,
            TotalCoupon,
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon = AvailableCoupon;
          this.GeneratedCoupon = GeneratedCoupon;
          this.AccumulatedCoupon = AccumulatedCoupon;
          this.UnusedExpiredCoupon = UnusedExpiredCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
      this.skyloEnd();
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      let loader = this.$loading.show();
      let formData = new FormData();
      formData.append('ProductSerails', this.uploadFile);
      commonServices
        .post_upload_file('kspgAPI/Coupon/upload', formData)
        .then(
          (responce) => {
            this.message = responce.data.message;
            if (responce.data.status) {
            }
          },
          (error) => {
            //   this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => {
        loader.hide();
      }, 1000);
    },
    exportReport(pageNum){
      this.exportData =  true;
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        0,
        0
      );
      params['exportData_page']=pageNum-1;
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/reportList', params)
        .then((response) => {
          loader.hide()
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'file.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        this.exportData =  false;
      //setTimeout(() => {}, 1000)
    }
  },
  computed: {
    selectAll:{
       get: function () {
                return this.userList ? this.PartnerMultiSelect.length == this.userList.length : false;
            },
        set: function (value) {
            var PartnerMultiSelect = [];

            if (value) {
                this.userList.forEach(function (user) {
                    PartnerMultiSelect.push(user.id);
                });
            }

            this.PartnerMultiSelect = PartnerMultiSelect;
        }
    },
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    }
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align {
  text-align: left !important;
}
</style>